"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarkBox = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = require("./Icon");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var check = function check(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.33333 8.64332L12.9933 0.982483L14.1725 2.16082L5.33333 11L0.0300002 5.69665L1.20833 4.51832L5.33333 8.64332Z",
    fill: "currentColor"
  }));
};
check.defaultProps = {
  width: "15",
  height: "11",
  viewBox: "0 0 15 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MarkBox = _styledComponents.default.div.attrs(function (_ref) {
  var checked = _ref.checked,
    disabled = _ref.disabled;
  return {
    children: /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      as: check,
      checked: checked,
      disabled: disabled
    })
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex: none;\n  cursor: ", ";\n  border: ", ";\n  background-color: ", ";\n  height: 24px;\n  width: 24px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  margin-right: 10px;\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? 'default' : 'pointer';
}, function (_ref3) {
  var theme = _ref3.theme;
  return "1px solid ".concat(theme.colors.secondaryShade2);
}, function (_ref4) {
  var theme = _ref4.theme,
    disabled = _ref4.disabled;
  return disabled && theme.colors.secondaryShade;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.secondaryShade;
});
exports.MarkBox = MarkBox;